import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption
} from '@angular/material/autocomplete';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ICategoriaMateriaPrima } from '@app/modules/categoria-materia-prima/model/categoria_materia_prima.model';
import { ICategoriaServico } from '@app/modules/categoria-servicos/model/categoria_servico.model';
import { ICentroResultado } from '@app/modules/centro_resultado/model/centro_resultado.model';
import { IPreCadastro } from '@app/modules/cliente/models/pre_cadastro.model';
import { ICombustivel } from '@app/modules/combustivel/model/combustivel.model';
import { IPreDeposito } from '@app/modules/deposito/models/pre_deposito.model';
import { IFabricante } from '@app/modules/fabricantes/models/fabricante.model';
import { IFormaPagamento } from '@app/modules/forma-pagamento/models/forma-pagamento.model';
import { IFornecedor } from '@app/modules/fornecedor/models/fornecedor.model';
import { IMarca } from '@app/modules/marca/model/marca.model';
import { IMateriaPrima } from '@app/modules/materia-prima/models/materia-prima.model';
import { IModeloTransporte } from '@app/modules/modelo_transporte/model/modelo_transporte.model';
import { IModelo } from '@app/modules/modelos/model/modelo.model';
import { IMotorista } from '@app/modules/motorista/models/motorista.model';
import { INaturezaFinanceira } from '@app/modules/natureza_financeira/model/natureza_financeira.model';
import { IPortador } from '@app/modules/portador/model/portador.model';
import { IProprietarioVeiculo } from '@app/modules/proprietario_veiculo/models/proprietario_veiculo.model';
import { IServicos } from '@app/modules/servicos/models/servicos.model';
import { ITabelaPreco } from '@app/modules/tabela-preco/model';
import { ITipoServicoCorreios } from '@app/modules/tipo_servico_correios/model/tipo_servico_correios.model';
import { IVariacaoMateria } from '@app/modules/variacao-materias/model/variacao-materias.model';
import { IVariacao } from '@app/modules/variacao-produtos/model/variacao.model';
import { IVeiculo } from '@app/modules/veiculo/model/veiculo.model';
import { IVendedor } from '@app/modules/vendedor/models/vendedor.model';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Observable } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import {
  EntityService,
  ErroMessages,
  IEntity,
  IErroMessages,
  IRoute,
  TokenService,
  Utils
} from 'viggo-sistemas-core-web';
import { ICategoriaProduto } from '../../../categoria-produtos/model/categoria_produto.model';
import { FastCategoriaMateriaPrimaComponent } from '../fast-categoria-materia-prima/fast-categoria-materia-prima.component';
import { FastCategoriaProdutoComponent } from '../fast-categoria-produto/fast-categoria-produto.component';
import { FastCategoriaServicosComponent } from '../fast-categoria-servico/fast-categoria-servico.component';
import { FastCentroResultadoComponent } from '../fast-centro-resultado/fast-centro-resultado.component';
import { FastClienteComponent } from '../fast-cliente/fast-cliente.component';
import { FastCombustivelComponent } from '../fast-combustivel/fast-combustivel.component';
import { FastDepositoComponent } from '../fast-deposito/fast-deposito.component';
import { FastFabricanteComponent } from '../fast-fabricante/fast-fabricante.component';
import { FastFormaPgmtComponent } from '../fast-forma-pgmt/fast-forma-pgmt.component';
import { FastFornecedorComponent } from '../fast-fornecedor/fast-fornecedor.component';
import { FastMarcaComponent } from '../fast-marca/fast-marca.component';
import { FastMateriaPrimaComponent } from '../fast-materia-prima/fast-materia-prima.component';
import { FastModeloTransporteComponent } from '../fast-modelo-transporte/fast-modelo-transporte.component';
import { FastModelosComponent } from '../fast-modelo/fast-modelo.component';
import { FastMotoristaComponent } from '../fast-motorista/fast-motorista.component';
import { FastNaturezaFinanceiraComponent } from '../fast-natureza-financeira/fast-natureza-financeira.component';
import { FastPortadorComponent } from '../fast-portador/fast-portador.component';
import { FastProprietarioVeiculoComponent } from '../fast-proprietario-veiculo/fast-proprietario-veiculo.component';
import { FastServicosComponent } from '../fast-servico/fast-servico.component';
import { FastTabelaComponent } from '../fast-tabela/fast-tabela.component';
import { FastTipoServicoCorreioComponent } from '../fast-tipo-servico-correio/fast-tipo-servico-correio.component';
import { FastVariacaoMateriaComponent } from '../fast-variacao-materia/fast-variacao-materia.component';
import { FastVariacaoProdutoComponent } from '../fast-variacao-produto/fast-variacao-produto.component';
import { FastVeiculoComponent } from '../fast-veiculo/fast-veiculo.component';
import { FastVendedorComponent } from '../fast-vendedor/fast-vendedor.component';

export type InsertType =
  | 'servico'
  | 'materia_prima'
  | 'modelo'
  | 'cliente'
  | 'vendedor'
  | 'forma_pgmt'
  | 'fornecedor'
  | 'fabricante'
  | 'categoria'
  | 'tabela_preco'
  | 'variacao_produto'
  | 'variacao_materia'
  | 'categoria_servico'
  | 'categoria_materia'
  | 'centro_resultado'
  | 'natureza_financeira'
  | 'portador'
  | 'combustivel'
  | 'marca'
  | 'tipo_servico_correio'
  | 'modelo_transporte'
  | 'proprietario_veiculo'
  | 'modelo_transporte'
  | 'motorista'
  | 'pre_deposito';

export const components: {
  [key: string]: { component: any; config: MatDialogConfig };
} = {
  fornecedor: {
    component: FastFornecedorComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IFornecedor
      }
    }
  },
  cliente: {
    component: FastClienteComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        // entity: {
        //   parceiro: {
        //     enderecos: [],
        //     contatos: []
        //   }
        // } as ICliente
        entity: {
          domain_id: '',
          cliente: { parceiro: {} }
        } as IPreCadastro
      }
    }
  },
  servico: {
    component: FastServicosComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IServicos
      }
    }
  },
  modelo: {
    component: FastModelosComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IModelo
      }
    }
  },
  materia_prima: {
    component: FastMateriaPrimaComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IMateriaPrima
      }
    }
  },
  fabricante: {
    component: FastFabricanteComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IFabricante
      }
    }
  },
  vendedor: {
    component: FastVendedorComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          },
          carteira: []
        } as IVendedor
      }
    }
  },
  categoria: {
    component: FastCategoriaProdutoComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {} as ICategoriaProduto
    }
  },
  tabela_preco: {
    component: FastTabelaComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as ITabelaPreco
      }
    }
  },
  variacao_produto: {
    component: FastVariacaoProdutoComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {
          itens: []
        } as IVariacao
      }
    }
  },
  variacao_materia: {
    component: FastVariacaoMateriaComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {
          itens: []
        } as IVariacaoMateria
      }
    }
  },
  categoria_servico: {
    component: FastCategoriaServicosComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as ICategoriaServico
      }
    }
  },
  categoria_materia: {
    component: FastCategoriaMateriaPrimaComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as ICategoriaMateriaPrima
      }
    }
  },
  centro_resultado: {
    component: FastCentroResultadoComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as ICentroResultado
      }
    }
  },
  combustivel: {
    component: FastCombustivelComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as ICombustivel
      }
    }
  },
  natureza_financeira: {
    component: FastNaturezaFinanceiraComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as INaturezaFinanceira
      }
    }
  },
  marca: {
    component: FastMarcaComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IMarca
      }
    }
  },
  tipo_servico_correio: {
    component: FastTipoServicoCorreioComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as ITipoServicoCorreios
      }
    }
  },
  proprietario_veiculo: {
    component: FastProprietarioVeiculoComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IProprietarioVeiculo
      }
    }
  },
  modelo_transporte: {
    component: FastModeloTransporteComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IModeloTransporte
      }
    }
  },
  motorista: {
    component: FastMotoristaComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {
          parceiro: {
            enderecos: [],
            contatos: []
          }
        } as IMotorista
      }
    }
  },
  veiculo: {
    component: FastVeiculoComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IVeiculo
      }
    }
  },
  portador: {
    component: FastPortadorComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IPortador
      }
    }
  },
  forma_pgmt: {
    component: FastFormaPgmtComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        entity: {} as IFormaPagamento
      }
    }
  },
  pre_deposito: {
    component: FastDepositoComponent,
    config: {
      position: {
        top: '0px'
      },
      panelClass: [
        'custom-container',
        'position-relative',
        'dialog-sem-padding'
      ],
      data: {
        // entity: {
        //   parceiro: {
        //     enderecos: [],
        //     contatos: []
        //   }
        // } as IDeposito
        entity: {
          domain_id: '',
          deposito: { parceiro: {} }
        } as IPreDeposito
      }
    }
  }
};

@Component({
  selector: 'fast-autocomplete',
  templateUrl: './fast-autocomplete.component.html',
  styleUrls: ['./fast-autocomplete.component.scss']
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class FastAutocompleteComponent<T extends IEntity = any>
  implements OnInit, OnChanges, OnDestroy {
  @Input() routesAuthorization: IRoute[] = [];
  @Input() data: any = {};
  @Input() useChange = false;
  @Input() controlReset = true;
  @Input() searchField = false;
  @Input() valueSearchField = '';

  @Input() insertType: InsertType | null = null;
  /**
   * Placeholder usado pelo input
   */
  @Input() placeholder = 'Digite aqui';
  /**
   * Exibe mensagem de erro, caso haja
   */
  @Input() errorMsg = '';
  /**
   * Mensagens de erro
   */
  @Input() messages: { [key: string]: string };

  @Input() displayField = 'id';

  @Input() displaySecondField = 'id';
  /**
   * Tipo de input do autocomplete
   */
  @Input() inputType = 'text';
  /**
   * Identifica se o campo é de preenchimento obrigatório
   */
  @Input() public readonly required = false;
  /**
   * Função para exibir os dados do autocomplete
   * @deprecated
   */
  @Input() displayWith: (obj: T) => string = obj => obj.toString();
  /**
   * O FormControl responsável por gerenciar o input
   * @required
   */
  @Input() control: UntypedFormControl;
  /**
   * Configuração de selecionar automaticamente o uncio resultado
   */

  @Input() public autoFirst: boolean = true;
  /**
   * Inicia dados preenchido quando a busca for vazia
   */

  @Input() public readonly initDataWithEmpty: boolean = false;
  /**
   * EntityService usado para buscar os resultados
   * exibidos pelo autocomplete
   * @required
   */

  @Input() entityService: EntityService<T>;
  /**
   * Caso o usuario queira repassar sua própria função de busca
   * É possível atravês dessa props
   */
  @Input() public readonly searchFN: (where: any) => Observable<any> = null;
  /**
   * Função chamada sempre que há uma requisição a API
   * Implementa lógica caso seja nescessário filtar as entidades
   * vindas do banco de dados, ex: impedir auto relacionamento de entidades
   * @param entities entidades vindas da requisição
   * @tutorial rulesFilterEntities Cuidado com a perda de contexto do "this" use arrow functions
   * ou tenha certeza que o contexto chamado seja da sua classe externa com o bind.
   */
  @Input() rulesFilterEntities: (entities: T[]) => T[] = entities => entities;

  /**
   * Quando os resultados são carregados da api, este evento é acionado, repassando
   * os resultados retornados da api
   */
  @Output() public onLoadResults = new EventEmitter<T[]>();
  @Output() public clearSelection = new EventEmitter<boolean>();

  filteredEntities: T[] = [];

  /**
   * Id do dominio onde a infomação deve ser pesquisada
   */
  @Input() domain_id: string;

  @Input() domainPath = 'domain_id';

  @Input() value_order: string;

  @Input() orderByPath = 'order_by';

  @Input() pageValue: number = 0;

  @Input() pagePath = 'page';

  @Input() pageSizeValue: number = 10;

  @Input() pageSizePath = 'page_size';

  pageLength = 0;

  @Input() public readonly include: string[] = null;

  @Input() showDropDown = true;

  @Input() list_options = 'ACTIVE_ONLY';

  /**
   * Caso o usuario queira repassar sua própria função de busca
   * É possível atravês dessa props
   */
  @Input() public openDialogAddEntity: () => void = null;

  /**
   * Mostra a entidade selecionada
   * @param entity entidade a ser mostrada
   */
  @Input() displayWithEntityFn = (entity: T | string) => {
    if (!entity) return '';
    if (typeof entity === 'string') return entity;
    return entity[this.displayField];
  };
  /**
   * É possivel repassar paremetros adicionais para a requisição
   */
  @Input() params: { [param: string]: string } = {};
  /**
   * Caso o usuario queira ter controle total sobre a montagem de paramentros adicionais, é possivel
   * repassar uma funcao que deve retornar uma string formatada com query params que serão inseridos
   * antes da requisção ser feita
   */
  @Input() buildParams: () => string = this.prepareParams;

  @Input() readonly = false;

  @Input() readonly interceptorService: EntityService<T> | null = null;

  @Input() interceptorPath = 'id';

  @Input() interceptorDomainPath = 'domain_id';

  @Input() actionState = true;

  @Input() showBtnDialog = false;

  @Input() controlIsEnabled = true;

  @Input() btnIcon = 'search';

  @Input() searchFieldPath = 'domain_id';

  @Input() public readonly interceptorInclude: string[] = null;

  @Input() useOnlyNumbers = false;

  @Input() entity_id: string;

  @Input() entityPathId = 'entity_id';

  /**
   * Emite eventos sempre que o autocomplete
   * precisar forçar a seleção de uma entidade
   * @description Emite o evento quando a entidade é selecionada
   */
  @Output() selectEntity: EventEmitter<T> = new EventEmitter();
  @Output() blur: EventEmitter<FocusEvent> = new EventEmitter();
  @Output() openDialog: EventEmitter<boolean> = new EventEmitter();

  @Input() forcedNotShowOptions = false;
  @Input() hiddenRemoveValue = false;

  public notShowOptions = false;
  public isLoading = false;
  public noResults = false;
  public stateSearch = false;
  valueControlStrChange = false;
  isClear = false;

  constructor(
    protected tokenService: TokenService,
    public matDialog: MatDialog,
    public matSnackBar: MatSnackBar,
    public router: Router
  ) {
    this.buildParams = this.prepareParams;
  }

  protected getSearchField = (searchFieldPath = this.searchFieldPath) =>
    this.valueSearchField ? `&${searchFieldPath}=${this.valueSearchField}` : '';

  protected getDomain = (domainPath = this.domainPath) =>
    this.domainId ? `&${domainPath}=${this.domainId}` : '';

  protected getOrderBy = (orderByPath = this.orderByPath) =>
    this.value_order ? `&${orderByPath}=${this.value_order}` : '';

  protected getPage = (pagePath = this.pagePath) =>
    this.pageValue >= 0 ? `&${pagePath}=${this.pageValue}` : '';

  protected getPageSize = (pageSizePath = this.pageSizePath) =>
    this.pageSizeValue ? `&${pageSizePath}=${this.pageSizeValue}` : '';

  protected getInclude = (include = this.include) =>
    include ? this.getParamsByInclude(include) : '';

  protected getListOptions = (list_options = this.list_options) =>
    `&list_options=${list_options}`;

  protected interceptFn = () => {
    if (this.interceptorService) {
      return mergeMap((entity: any) => {
        return this.interceptorService
          .getEntitiesByParams(
            `${this.getDomain(this.interceptorDomainPath)}${this.getInclude(
              this.interceptorInclude
            )}`
          )
          .pipe(
            map(interceptorEntities => {
              return interceptorEntities.data.reduce((acc, crr) => {
                return entity.data.filter(
                  p =>
                    Utils.getDescendantProp(p, this.interceptorPath) ===
                    Utils.getDescendantProp(crr, this.interceptorPath)
                ).length > 0
                  ? [...acc, crr]
                  : acc;
              }, []);
            })
          );
      });
    }
    return map((entity: any) => entity.data);
  };

  @ViewChild('auto') itensAutocomplete: MatAutocomplete;
  @ViewChild('trigger') trigger: MatAutocompleteTrigger;
  lastScrollTop = 0;
  keyEntities = 0;

  scroll = (event): void => {
    const element = this.itensAutocomplete.panel?.nativeElement;
    if (element) {
      if (element.scrollTop < this.lastScrollTop) {
        // upscroll
        return;
      }
      this.lastScrollTop = element.scrollTop <= 0 ? 0 : element.scrollTop;
      if (element.scrollTop + element.offsetHeight >= element.scrollHeight) {
        if (
          this.filteredEntities.length > 0 &&
          this.filteredEntities.length !== this.pageLength
        ) {
          this.pageValue++;
          var strFilter = null;
          if (
            this.control.value &&
            this.control.value !== '' &&
            typeof this.control.value === 'string'
          )
            strFilter = this.control.value.trim();
          this.onLoad(strFilter);
        }
      }
    }
  };

  onKeyEnter(event) {
    const elementTrigger = this.trigger;
    const elementPanelAt = this.itensAutocomplete;
    if (
      elementTrigger &&
      !elementTrigger.activeOption &&
      !this.control.value &&
      typeof (event.target as any).value === 'string' &&
      event.key === 'Enter' &&
      event.keyCode === 13
    ) {
      if (this.isLastValueActivated) {
        this.control.setValue(this.isLastValueActivated);
        elementPanelAt.options
          .toArray()
          .find(it => it.value && it.value.id === this.isLastValueActivated.id)
          .select();
      } else {
        this.stateSearch = true;
        this.valueControlStrChange = false;
        this.pageValue = 0;
        this.lastScrollTop = 0;
        this.keyEntities = 0;
        this.filteredEntities = [];
        this.onLoad((event.target as any).value.trim());
      }
    }
  }

  onKeyDown(event) {
    const elementPanelAt = this.itensAutocomplete.panel?.nativeElement;
    const elementTrigger = this.trigger;
    if (
      elementPanelAt &&
      elementTrigger &&
      elementTrigger.activeOption &&
      elementTrigger.activeOption.value &&
      elementTrigger.activeOption.id !== 'addBtn' &&
      event.key === 'ArrowDown' &&
      event.keyCode === 40
    ) {
      this.keyEntities =
        this.filteredEntities.findIndex(
          it => it.id === this.trigger.activeOption.value.id
        ) + 1;
      if (this.keyEntities >= this.filteredEntities.length) {
        if (
          this.filteredEntities.length > 0 &&
          this.filteredEntities.length !== this.pageLength
        ) {
          this.pageValue++;
          var strFilter = null;
          if (
            this.control.value &&
            this.control.value !== '' &&
            typeof this.control.value === 'string'
          )
            strFilter = this.control.value.trim();
          this.onLoad(strFilter, event);
        }
      }
    } else if (
      ((elementPanelAt &&
        elementTrigger &&
        elementTrigger.activeOption &&
        elementTrigger.activeOption.id === 'addBtn') ||
        this.isBtnActive) &&
      event.key === 'Enter' &&
      event.keyCode === 13
    ) {
      this.isBtnActive = false;
      if (this.openDialogAddEntity) this.openDialogAddEntity();
      else this.openDialogFast();
    }
  }

  isLastActivated: MatOption;
  isLastValueActivated: any;
  isBtnActive: boolean = false;
  onOptionActivated(e: { source: MatAutocomplete; option: MatOption }) {
    if (e && e.option && e.option.value) {
      this.isBtnActive = false;
      this.isLastActivated = e.option;
      this.isLastValueActivated = e.option.value;
    } else if (e && e.option && e.option.id === 'addBtn')
      this.isBtnActive = true;
    else this.isBtnActive = false;
  }

  forcedSelectedAndActivatedOption(event) {
    if (this.isLastActivated && this.itensAutocomplete && this.trigger) {
      var firstEnabledOptionIndex = -1;
      const element = this.isLastActivated._getHostElement();
      const newScrollPosition = this._getOptionScrollPosition(
        element.offsetTop,
        element.offsetHeight,
        this.itensAutocomplete._getScrollTop(),
        this.itensAutocomplete.panel?.nativeElement.offsetHeight
      );
      this.itensAutocomplete._setScrollTop(newScrollPosition);

      for (
        let index = 0;
        index < this.itensAutocomplete.options.length;
        index++
      ) {
        const option = this.itensAutocomplete.options.get(index)!;
        if (
          !option.disabled &&
          option.value &&
          option.value.id === this.isLastActivated.value.id
        ) {
          firstEnabledOptionIndex = index;
          break;
        }
      }

      this.itensAutocomplete._keyManager.setActiveItem(firstEnabledOptionIndex);
      this.itensAutocomplete._keyManager.activeItem.focus();
      // this.trigger.writeValue(
      //   this.itensAutocomplete._keyManager.activeItem.value
      // );
      // event.target.value = this.itensAutocomplete._keyManager.activeItem.value[
      //   this.displayField
      // ];
    }
  }

  _getOptionScrollPosition(
    optionOffset: number,
    optionHeight: number,
    currentScrollPosition: number,
    panelHeight: number
  ): number {
    if (optionOffset < currentScrollPosition) {
      return optionOffset;
    }

    if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
      return Math.max(0, optionOffset - panelHeight + optionHeight);
    }

    return currentScrollPosition;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.tokenService.isLoggedIn()) {
      if (changes && this.useChange) {
        var reload = false;
        if (
          changes.searchField &&
          changes.searchField.currentValue !== undefined
        ) {
          this.searchField = changes.searchField.currentValue;
          this.stateSearch = true;
          this.notShowOptions = true;
          this.pageValue = 0;
          this.lastScrollTop = 0;
          this.keyEntities = 0;
          this.filteredEntities = [];
          reload = true;
        }
        if (
          changes.controlReset &&
          changes.controlReset.currentValue !== undefined
        ) {
          this.controlReset = changes.controlReset.currentValue;
          this.stateSearch = true;
          this.notShowOptions = true;
          this.pageValue = 0;
          this.lastScrollTop = 0;
          this.keyEntities = 0;
          this.filteredEntities = [];
          reload = true;
        }
        if (
          changes.valueSearchField &&
          changes.valueSearchField.currentValue !== undefined
        ) {
          this.valueSearchField = changes.valueSearchField.currentValue;
          this.stateSearch = true;
          this.notShowOptions = true;
          this.pageValue = 0;
          this.lastScrollTop = 0;
          this.keyEntities = 0;
          this.filteredEntities = [];
          reload = true;
        }
        if (reload) {
          this.onLoad(null);
        }
      }
    }
  }

  onSearch() {
    if (
      this.control.value &&
      this.control.value !== '' &&
      typeof this.control.value === 'string'
    ) {
      this.stateSearch = true;
      this.valueControlStrChange = false;
      this.pageValue = 0;
      this.lastScrollTop = 0;
      this.keyEntities = 0;
      this.filteredEntities = [];
      this.onLoad(this.control.value.trim());
    }
  }

  onLoad(textFilter: string, event?) {
    this.isLoading = true;
    if (this.searchFN) {
      this.isLoading = true;
      const where = {
        include: this.include,
        order_by: this.value_order,
        page: this.pageValue,
        page_size: this.pageSizeValue,
        require_pagination: true,
        [this.domainPath]: this.domainId,
        list_options: 'ACTIVE_ONLY'
      };

      //TODO: DPS PODE MELHORAR ISSO POR ENQUANTO TA SENDO USADO NO AUTOCOMPLETE DE DEPOSITO NA TRANSFERENCIA
      if (this.searchFieldPath && this.searchFieldPath.includes('&')) {
        const splitSearchField = this.searchFieldPath.split('&');
        splitSearchField.forEach((field, index) => {
          if (field.includes('='))
            where[field.split('=')[0]] = field.split('=')[1];
          else where[field] = this.valueSearchField;
        });
      } else {
        where[this.searchFieldPath] = this.valueSearchField;
      }

      if (this.entity_id) where[this.entityPathId] = this.entity_id;

      if (textFilter)
        where[this.displayField] = this.useOnlyNumbers
          ? `${textFilter}`
          : `${textFilter}%`;

      this.searchFN(where)
        .pipe(
          map(entities => this.rulesFilterEntities(entities)),
          tap(entities => {
            this.noResults = entities.data.length === 0;
            this.pageLength = entities.pagination.total;
            this.isLoading = true;
          }),
          this.interceptFn()
        )
        .subscribe(
          entities => {
            this.isLoading = false;
            if (!this.forcedNotShowOptions) this.notShowOptions = false;
            if (
              (this.useChange &&
                this.filteredEntities.length === 0 &&
                Number(this.pageValue) === 0) ||
              (this.pageValue > 0 && this.filteredEntities.length !== 0)
            )
              this.filteredEntities = this.filteredEntities.concat(entities);
            else this.filteredEntities = this.filteredEntities.concat(entities);
            if (event) this.forcedSelectedAndActivatedOption(event);
            if (
              this.filteredEntities &&
              this.filteredEntities.length !== 0 &&
              this.autoFirst
            ) {
              this.control.setValue(this.filteredEntities[0]);
              this.selectEntity.emit(this.filteredEntities[0]);
            }
          },
          (err: HttpErrorResponse) => {
            this.displayError(err);
          }
        );
    } else {
      const anotherParams = this.buildParams();

      let url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}`;
      if (textFilter) {
        url += `&${this.displayField}=${textFilter}%`;
        if (
          !Number.isNaN(Number(textFilter)) &&
          this.displaySecondField === 'id'
        ) {
          url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}&${
            this.displayField
          }=${textFilter}`;
        } else if (
          (/^[A-Za-z0-9]*$/.test(textFilter) || /\s/g.test(textFilter)) &&
          this.displaySecondField !== 'id'
        ) {
          if (/^\d+$/.test(textFilter) && this.displaySecondField !== 'id') {
            url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}&${
              this.displaySecondField
            }=${textFilter}%`;
          } else {
            url = `${this.getDomain()}${this.getSearchField()}${this.getInclude()}${this.getOrderBy()}${this.getPage()}${this.getPageSize()}${this.getListOptions()}&${
              this.displayField
            }=${textFilter}%`;
          }
        }
      }
      if (anotherParams) url += `&${anotherParams}`;
      this.entityService
        .getEntitiesByParams(url, undefined, true)
        .pipe(
          map(entities => this.rulesFilterEntities(entities)),
          tap(entities => {
            this.noResults = entities.data.length === 0;
            this.pageLength = entities.pagination.total;
          }),
          this.interceptFn()
        )
        .subscribe(
          entities => {
            this.isLoading = false;
            if (!this.forcedNotShowOptions) this.notShowOptions = false;
            if (
              (this.useChange &&
                this.filteredEntities.length === 0 &&
                Number(this.pageValue) === 0) ||
              (this.pageValue > 0 && this.filteredEntities.length !== 0)
            )
              this.filteredEntities = this.filteredEntities.concat(entities);
            else this.filteredEntities = this.filteredEntities.concat(entities);
            if (event) this.forcedSelectedAndActivatedOption(event);
            if (
              this.filteredEntities &&
              this.filteredEntities.length !== 0 &&
              this.autoFirst
            ) {
              this.control.setValue(this.filteredEntities[0]);
              this.selectEntity.emit(this.filteredEntities[0]);
            }
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    }
  }

  ngOnInit() {
    window.addEventListener('scroll', this.scroll, true);
    if (!this.useChange) {
      this.stateSearch = true;
      this.notShowOptions = true;
      this.onLoad(null);
    }
    this.validateInputs();
    this.control.valueChanges.subscribe(text => {
      if (this.stateSearch) {
        if (typeof text === 'string') {
          if (text === '') {
            this.clearSelectValue();
          } else {
            this.valueControlStrChange = true;
            // this.notShowOptions = true;
          }
        }
        // else if (typeof text === 'object' && !text) {
        //   this.clearSelectValue();
        // }
      } else if (typeof text === 'string') {
        if (text === '') {
          this.clearSelectValue();
        } else {
          this.valueControlStrChange = true;
          // this.notShowOptions = true;
        }
      } else {
        this.valueControlStrChange = false;
      }
    });
  }

  confirmSelection(entity) {
    this.control.setValue(entity);
    this.selectEntity.emit(entity);
  }

  /**
   * Monta os paramentros adicionais a serem inseridos a request
   */
  private prepareParams(): string {
    if (!this.params) return '';
    const { params } = this;
    return Object.keys(params)
      .filter(key => params[key])
      .map(key => `${key}=${params[key]}`)
      .join('&');
  }
  private validateInputs() {
    if (!this.entityService && !this.searchFN) {
      throw new Error('EntityService or seach FN is required');
    }
    if (!this.control) {
      throw new Error('Formcontrol is required');
    }
  }
  /**
   * Pesquisa por uma entidade com base em um texto
   * @param value valor a ser buscao
   */
  protected getResults(value: string): Observable<T[]> {
    const anotherParams = this.buildParams();
    let url = `${
      this.displayField
    }=${value}%${this.getOrderBy()}${this.getPage()}${this.getPageSize()}`;
    if (anotherParams) url += `&${anotherParams}`;
    return this.entityService.getEntitiesByParams(url, this.domain_id, true);
  }

  getParamsByInclude(includes: string[]): string {
    if (includes.length > 0) return `&include=${includes.join(',')}`;
    return '';
  }
  getKey(): string {
    return Object.keys(this.control.errors)[0];
  }

  get domainId(): string {
    if (this.domain_id) return this.domain_id;
    else if (this.domain_id === undefined) return;
    else return this.tokenService.getDomain().id;
  }

  openDialogFast(): void {
    if (this.insertType) {
      if (this.insertType === 'materia_prima' && this.valueSearchField)
        components[
          this.insertType
        ].config.data.entity.descricao_categoria = this.valueSearchField;
      if (this.insertType === 'natureza_financeira' && this.valueSearchField)
        components[
          this.insertType
        ].config.data.entity.tipo = this.valueSearchField;
      this.matDialog
        .open(components[this.insertType].component, {
          ...components[this.insertType].config,
          disableClose: true,
          panelClass: components[this.insertType].config.panelClass,
          position: components[this.insertType].config.position,
          data: {
            ...components[this.insertType].config.data,
            ...this.data
          }
        })
        .afterClosed()
        .subscribe(componentEntity => {
          this.notShowOptions = false;
          if (componentEntity) {
            this.control.setValue(componentEntity);
            this.filteredEntities = [componentEntity, ...this.filteredEntities];
            this.noResults = false;
          } else {
            this.control.setValue(null);
            this.clearSelectValue();
          }
        });
    }
  }

  enterSearch(event: KeyboardEvent) {
    if (event.key === 'Enter' && event.keyCode === 13) {
      if (
        this.control.value &&
        this.control.value !== '' &&
        typeof this.control.value === 'string'
      ) {
        this.onSearch();
      } else {
        this.onKeyEnter(event);
      }
    }
  }

  getBtnIcon() {
    if (
      !this.hiddenRemoveValue &&
      ((typeof this.control.value === 'object' && this.control.value) ||
        (typeof this.control.value === 'string' &&
          this.control.value !== '' &&
          this.noResults))
    ) {
      return 'pi pi-times-circle';
    } else if (
      this.filteredEntities.length !== 0 &&
      !this.valueControlStrChange
    ) {
      return 'pi pi-angle-down';
    } else if (
      typeof this.control.value === 'string' &&
      this.valueControlStrChange
    ) {
      return 'pi pi-search';
    }
  }

  getBtnSeverity() {
    if (
      !this.hiddenRemoveValue &&
      ((typeof this.control.value === 'object' && this.control.value) ||
        (typeof this.control.value === 'string' &&
          this.control.value !== '' &&
          this.noResults))
    ) {
      return 'danger';
    } else if (
      this.filteredEntities.length !== 0 &&
      !this.valueControlStrChange
    ) {
      return 'primary';
    } else if (
      typeof this.control.value === 'string' &&
      this.valueControlStrChange
    ) {
      return 'primary';
    }
  }

  getBtnAction() {
    if (
      !this.hiddenRemoveValue &&
      ((typeof this.control.value === 'object' && this.control.value) ||
        (typeof this.control.value === 'string' &&
          this.control.value !== '' &&
          this.noResults))
    ) {
      return this.clearSelectValue();
    } else if (
      this.filteredEntities.length !== 0 &&
      !this.valueControlStrChange
    ) {
      return null;
    } else if (
      typeof this.control.value === 'string' &&
      this.valueControlStrChange
    ) {
      return this.onSearch();
    }
  }

  clearSelectValue() {
    this.notShowOptions = true;
    this.isLoading = false;
    this.stateSearch = false;
    this.noResults = false;
    this.isClear = true;
    this.filteredEntities = [];
    this.pageValue = 0;
    this.lastScrollTop = 0;
    this.keyEntities = 0;
    this.clearSelection.emit(true);
    this.onLoad(null);
  }

  dialogClick() {
    this.notShowOptions = true;
    this.openDialog.emit(true);
  }

  validateOnlyNumbers(event) {
    if (event.key === 'ArrowDown') {
      this.onKeyDown(event);
    } else if (
      !/^\d+$/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scroll, true);
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
